import { withErrorBoundary } from 'app/components/error-boundary';
import { Column, Row } from 'app/design/primitives/box';
import { useScopedTranslation } from 'app/hooks/i18n';
import type { NavigationScreen } from 'app/types/navigation';
import Constants from 'expo-constants';
import { useDeviceWidth } from 'app/hooks/use-device-size';

import { Button } from 'app/design/primitives/button';
import React, { useEffect } from 'react';
import { DisconnectedPrompt } from 'app/screens/billboard/all-listings/components/disconnected-prompt';
import { Text } from 'app/design/primitives/text';
import { ScrollView } from 'react-native';
import { LoginSheet, useLoginSheet } from 'app/screens/onboarding/login';
import { usePageTitle } from 'app/utils/web-helpers';
import { LogoRenderer } from 'app/design/branding/logo';
import { createTheme as createDSTheme } from 'app/shopify';
import { IconChevronDown, IconX } from '@tabler/icons-react-native';
import { ICON_STROKE_WIDTH } from 'app/utils/constants';
const theme = createDSTheme();

const IntroScreenComponent: NavigationScreen<'onboardingIntro'> = ({ navigation }) => {
  const { t } = useScopedTranslation();
  const w = useDeviceWidth();

  const setPageTitle = usePageTitle('onboardingIntro');
  useEffect(() => setPageTitle('title'), [setPageTitle]);

  const closeScreen = () => {
    navigation.goBack();
  };

  // Start the close screen animation after the bottomSheet animation finished
  const closeScreenWithDelay = () => {
    setTimeout(closeScreen, 300);
  };

  const { loginSheetState } = useLoginSheet();

  return (
    <>
      <Column
        style={{
          paddingTop: Constants.statusBarHeight,
          backgroundColor: theme.colors['surface.tertiary'],
          alignItems: 'center',
          height: '100%',
        }}
      >
        <Row alignItems="center" alignSelf="flex-start" style={{ height: 50 }}>
          <Button flex={1} onPress={closeScreen} style={{ maxWidth: 50 }}>
            <IconX strokeWidth={ICON_STROKE_WIDTH} />
          </Button>
        </Row>

        <ScrollView
          style={{
            position: 'absolute',
            bottom: theme.spacing['spacing.general.x12'],
            maxWidth: '100%',
          }}
        >
          <Column gap="spacing.general.x6">
            <Column alignItems="center" gap="spacing.general.x6" paddingHorizontal="spacing.general.x12">
              <LogoRenderer width={w} color={theme.colors['text.primary']} />

              <Text color="text.primary" fontSize={28} fontWeight="700" textAlign="center">
                {t('title')}
              </Text>

              <Text color="text.primary" textAlign="center" variant="headerXSmall">
                {t('text')}
              </Text>

              <IconChevronDown strokeWidth={ICON_STROKE_WIDTH} color={theme.colors['text.primary']} />
            </Column>

            <Column style={{ marginTop: -theme.spacing['spacing.general.x6'] }}>
              <DisconnectedPrompt backgroundColor="surface.disabled" showIntro={false} textColor="text.primary" />
            </Column>
          </Column>
        </ScrollView>
      </Column>
      <LoginSheet onLoginComplete={closeScreenWithDelay} state={loginSheetState} />
    </>
  );
};

export const IntroScreen: NavigationScreen<'onboardingIntro'> = withErrorBoundary(IntroScreenComponent);
